import { gql } from 'graphql-request'

export const TOGGLE_BOOK_COLLECTION_LIKE = gql`
  mutation ToggleBookCollectionLike($input: UserBookCollectionLikeInput!) {
    toggleBookCollectionLike(input: $input) {
      type
      status
    }
  }
`
